import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import notify from 'devextreme/ui/notify';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const UNAUTHENTICATED_PATHS = ['/auth/login', '/auth/login2step', '/auth/forgot-password', '/auth/verify-code', '/auth/restore-password', '/auth/logout'];

@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  private redirecting = false;

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const isAuthEndpoint = UNAUTHENTICATED_PATHS.some(path => req.url.endsWith(path));

        if (err.status === 401 && !isAuthEndpoint && !this.redirecting && this.router.url !== '/login') {
          this.redirecting = true;
          this.authService.logout().subscribe();
          notify('Su sesión ha expirado, inicie sesión nuevamente.', 'warning', 4000);
          this.router.navigate(['/login']).finally(() => {
            this.redirecting = false;
          });
        }

        return throwError(() => err);
      })
    );
  }
}
